export enum DropdownMenuTriggerType {
  Hover = 'hover',
  Click = 'click'
}
